import { makeStyles } from '../../../styles';
const useStyles = makeStyles(() => ({
    root: {
        '& .MuiCardContent-root': {
            padding: 10,
        },
    },
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    content: {
        paddingLeft: 10,
    },
}));
export default useStyles;
//# sourceMappingURL=TimerCard.styles.js.map